<template>
<div class="login">
  <div class="wrapper">
    <h3>Sign in</h3>
    <el-input type="text" placeholder="Email" v-model="email"/><br>
    <el-input type="password" placeholder="Password" v-model="password" @enter="login"/><br>
    <el-button @click="login">Connection</el-button>
  </div>
</div>
</template>
<script>

import authentication from 'services/authentication.js'

export default {
  data () {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    async login () {
      try {
        await authentication.setSessionMode()
        await authentication.signInWithEmailAndPassword(this.email, this.password)
        this.$router.replace('admin')
      } catch (err) {
        alert(`Oops. ${err.message}`)
      }
    }
  }
}
</script>
<style scoped lang="less">
  @import '~el-style/variables';

  .login {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;
    background-color: #f9f9f9;
  }

  .wrapper {
    margin-top: 50px;
    display: flex;
    width: 100%;
    max-width: 200px;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    align-self: center;
    background-color: #ffffff;
    box-shadow: @shadow;
    padding: 20px 30px;
    border-radius: @radius-small;
  }

  h3 {
    margin: 0px;
    padding: 0px;
    margin-bottom: 20px;
  }
</style>
